import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { StaticImage } from 'gatsby-plugin-image';
import bgImage from './part-time-info-card-bg.png';

const PartTimeInfoCard = () => {
  const isXs = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        width: '483px',
        height: '98px',
        maxWidth: '100%',
        position: 'relative',
        border: '2px solid #4520AB',
        background: `url(${bgImage}) no-repeat`,
        backgroundColor: 'kit.background.middlepurple',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        borderRadius: '16px',
        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.15)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <StaticImage
        src="./pin-icon.png"
        alt="Pin icon"
        placeholder="blurred"
        layout="fixed"
        style={{
          position: 'absolute',
          top: isXs ? '-20px' : '-30px',
          right: isXs ? '0px' : '-4px',
          zIndex: 1,
          width: isXs ? '34px' : '46px',
          height: isXs ? '41px' : '55px',
        }}
      />
      <Typography
        variant="h6"
        sx={{
          fontFamily: '"RF Rostin", sans-serif',
          fontSize: { xs: '22px', md: '24px' },
          fontWeight: 400,
          color: '#111111',
          letterSpacing: '-1.44px',
          lineHeight: 1.2,
          padding: { xs: '0 20px', md: '0 38px' },
        }}
      >
        Программы Part-Time и&nbsp;Full-Time одинаковы по&nbsp;содержанию!
      </Typography>
    </Box>
  );
};

export default PartTimeInfoCard;
